<h2 mat-dialog-title class="text-lg font-bold mb-1">
    {{this.data?.type == 'copy' ? 'Copiar' : 'Dividir' }} Registro
</h2>
<mat-dialog-content class="modal-content">
  <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSource" matSort
    (matSortChange)="changeSort($event)" matSortDisableClear>
    
    <ng-container matColumnDef="check">
      <th mat-header-cell *matHeaderCellDef class=" text-left first-col">
        <mat-checkbox color="primary"
          (change)="$event ? masterToggle() : null; onCheckboxChange($event)"
          [checked]="selection.hasValue() && isAllSelected()"
          [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let detail" class=" text-left first-col">
        <mat-checkbox color="primary"
          (click)="$event.stopPropagation(); onCheckboxChange($event, detail)"
          (change)="$event ? selection.toggle(detail) : null;"
          [checked]="selection.isSelected(detail)"
          [aria-label]="checkboxLabel(detail)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="material">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">
        <span style="margin-left: 5px;">Material</span>
      </th>
      <td mat-cell *matCellDef="let detail" class="text-left first-col table-text">
        <p class="table-text-m">
          <span class="table-text-code">
            {{ detail?.material?.externalKeys?.code ? detail?.material?.externalKeys?.code : detail.material?.code }}
          </span><br>
          <span>
            {{ detail.material?.name }}
          </span>
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="warehouse">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Almacén</th>
      <td mat-cell *matCellDef="let detail" class=" text-left first-col table-text">
        <p class="table-text-m">
          <span class="table-text-code">{{ detail?.warehouse?.externalKeys?.code ? detail.warehouse.externalKeys.code : '' }}</span><br>
          {{ detail.warehouse?.name }}
        </p>
      </td>
    </ng-container>
    
    <ng-container matColumnDef="soldQuantity">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Cantidad (U.M)</th>
      <td mat-cell *matCellDef="let detail" class=" text-left first-col table-text">
        <p class="table-text-m-2 pd-l">
          {{ (detail?.soldQuantity | number : '1.3') }} ({{detail?.soldUnitOfMeasure?.name}}) <br>
          <app-unit-measure-display
            [baseUnit]="{
              quantity: detail?.baseQuantity,
              unitId: detail?.baseUnitOfMeasure?._id,
              unitName: detail?.baseUnitOfMeasure?.name,
              unitAbbreviation: detail?.baseUnitOfMeasure?.code
            }"
            [parallelUnit]="{
              quantity: detail?.pararellQuantity,
              unitId: detail?.pararellUnitOfMeasure?._id,
              unitName: detail?.pararellUnitOfMeasure?.name,
              unitAbbreviation: detail?.pararellUnitOfMeasure?.code
            }"
            [material]="{
              _id: detail?.material?._id,
              code: detail?.material?.code,
              UMPActive: detail?.material?.UMPActive
            }"
            [companyUMPActive]="UMPActive"
            [statusId]="detail.statusId"
          ></app-unit-measure-display>
        </p>
      </td>
    </ng-container>
    
    <ng-container matColumnDef="unitPrice">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-right first-col table-tittle">Precio</th>
      <td mat-cell *matCellDef="let detail" class=" text-right first-col table-text">
        <span>
          {{ (detail?.unitPrice | DecimalFormatPipe)}}
        </span>
      </td>
    </ng-container>
    
    <ng-container matColumnDef="subTotal">
      <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="px-6 text-right first-col table-tittle">SubTotal</th>
      <td mat-cell *matCellDef="let detail" class=" text-right first-col table-text">
        <span>
          {{ (detail?.subTotal | DecimalFormatPipe) }}
        </span>
      </td>
    </ng-container>
    
    <ng-container matColumnDef="totalSurcharges">
      <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="px-6 text-right first-col table-tittle">Recargo</th>
      <td mat-cell *matCellDef="let detail" class=" text-right first-col table-text">
        <span>
          {{ (detail?.totalSurcharges | DecimalFormatPipe) }}
        </span>
      </td>
    </ng-container>
    
    <ng-container matColumnDef="totalDiscounts">
      <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="px-6 text-right first-col table-tittle">Descuento</th>
      <td mat-cell *matCellDef="let detail" class=" text-right first-col table-text">
        <span>
          {{ (detail?.totalDiscounts | DecimalFormatPipe) }}
        </span>
      </td>
    </ng-container>
    
    <ng-container matColumnDef="totalTaxes">
      <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="px-6 text-right first-col table-tittle">Impuesto</th>
      <td mat-cell *matCellDef="let detail" class=" text-right first-col table-text">
        <span>
          {{ (detail?.totalTaxes | DecimalFormatPipe) }}
        </span>
      </td>
    </ng-container>
    
    <ng-container matColumnDef="total">
      <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="px-6 text-right first-col table-tittle">Total</th>
      <td mat-cell *matCellDef="let detail" class=" text-right first-col table-text">
        <span>
          {{ (detail?.total | DecimalFormatPipe) }}
        </span>
      </td>
    </ng-container>

    <!-- Header Row -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
    <!-- Fila principal -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
  
  </table>

</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button
    mat-raised-button
    color="primary"
    (click)="openConfirmationDialog()"
    class="justify-end"
    [disabled]="this.selection.selected.length == 0"
  >
    {{this.data?.type == 'copy' ? 'Copiar' : 'Dividir' }}
  </button>
</mat-dialog-actions>

<ng-template #orderConfirmationDialog let-data style="width: 400px !important;">
  <div class="flex items-start space-x-2 mb-4" >
    <div class="flex items-center">
      <mat-icon
        svgIcon="heroicons_outline:exclamation-triangle"
        class="text-yellow-500 ml-4 mt-6"
        style="font-size: 32px"
      ></mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        Confirmar {{this.data?.type == 'copy' ? 'copia' : 'división' }}
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>¿Está seguro que desea {{this.data?.type == 'copy' ? 'copiar' : 'dividir' }} el registro?</p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">
      Aceptar
    </button>
  </mat-dialog-actions>
</ng-template>